import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { useTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import defined from "terriajs-cesium/Source/Core/defined";
import SplitDirection from "terriajs-cesium/Source/Scene/SplitDirection";
import CommonStrata from "../../../Models/Definition/CommonStrata";
import hasTraits from "../../../Models/Definition/hasTraits";
import Box from "../../../Styled/Box";
import { RawButton } from "../../../Styled/Button";
import Spacing from "../../../Styled/Spacing";
import SplitterTraits from "../../../Traits/TraitsClasses/SplitterTraits";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const LeftRightButton = styled(RawButton).attrs({
  fullWidth: true
}).withConfig({
  displayName: "LeftRightSection__LeftRightButton",
  componentId: "sc-1fhiwhk-0"
})(["text-align:center;padding:5px;color:", ";background-color:", ";", " &:hover,&:focus{background-color:", ";}"], p => p.theme.textLight, p => p.theme.dark, p => p.isActive && "\n    background-color: ".concat(p.theme.colorSecondary, ";\n  "), p => p.theme.colorSecondary);
const LeftRightSection = observer(_ref => {
  let {
    item
  } = _ref;
  const goLeft = () => {
    runInAction(() => {
      item.setTrait(CommonStrata.user, "splitDirection", SplitDirection.LEFT);
    });
  };
  const goBoth = () => {
    runInAction(() => {
      item.setTrait(CommonStrata.user, "splitDirection", SplitDirection.NONE);
    });
  };
  const goRight = () => {
    runInAction(() => {
      item.setTrait(CommonStrata.user, "splitDirection", SplitDirection.RIGHT);
    });
  };
  const {
    t
  } = useTranslation();
  const splitDirection = item.splitDirection;
  if (!hasTraits(item, SplitterTraits, "splitDirection") || item.disableSplitter || !defined(splitDirection) || !item.terria.showSplitter) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Spacing, {
      bottom: 3
    }), /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(LeftRightButton, {
        type: "button",
        onClick: goLeft,
        title: t("splitterTool.workbench.goleftTitle"),
        isActive: splitDirection === SplitDirection.LEFT,
        children: t("splitterTool.workbench.goleft")
      }), /*#__PURE__*/_jsx(LeftRightButton, {
        type: "button",
        onClick: goBoth,
        title: t("splitterTool.workbench.bothTitle"),
        isActive: splitDirection === SplitDirection.NONE,
        children: t("splitterTool.workbench.both")
      }), /*#__PURE__*/_jsx(LeftRightButton, {
        type: "button",
        onClick: goRight,
        title: t("splitterTool.workbench.gorightTitle"),
        isActive: splitDirection === SplitDirection.RIGHT,
        children: t("splitterTool.workbench.goright")
      })]
    })]
  });
});
export default withTranslation()(LeftRightSection);